var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.01024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 569.2m-10 0a10 10 0 1 0 20 0 10 10 0 1 0-20 0Z",
    fill: "#E73B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.8 617.1H406.5L108 390.3v20.1l293 222.7h216l299-223.3v-20L611.8 617.1z",
    fill: "#E73B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 256.8v-94.5H320v94.5H64v605h896v-605H704z m-340-50.5h296v50.4H364v-50.4z m552 611.5H108V769h808v48.8z m0-64.9H108V300.8h808v452.1z",
    fill: "#39393A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessSvgrepoCom);
export default __webpack_public_path__ + "static/media/business-svgrepo-com.f60cd965b4ceb3a784c2131f8732ff3e.svg";
export { ForwardRef as ReactComponent };